var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.74357C0 6.16449 0.287607 5.62183 0.77052 5.28975L7.99633 0.320795C8.61833 -0.106932 9.44619 -0.106931 10.0682 0.320796L17.294 5.28975C17.7769 5.62183 18.0645 6.16449 18.0645 6.74357V16.2899C18.0645 17.27 17.2557 18.0645 16.2581 18.0645H1.80645C0.808776 18.0645 0 17.27 0 16.2899V6.74357Z",
    fill: "#FF8E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16211 11.871C5.16211 11.3722 5.59538 10.9678 6.12985 10.9678H11.9363C12.4708 10.9678 12.904 11.3722 12.904 11.871V19.0968C12.904 19.5956 12.4708 20 11.9363 20H6.12985C5.59538 20 5.16211 19.5956 5.16211 19.0968V11.871Z",
    fill: "#F600C1",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.472f48d9af4f7fcde531b72bff1f8854.svg";
export { ForwardRef as ReactComponent };